import { ReactElement } from 'react';
import { NoResults as CoreNoResults } from '@client/catalog/components/NoResults';
import { ICON_TYPE } from '@client/common/components/InfoView';
import image from './assets/vase.jpg';
import retinaImage from './assets/vase@2x.jpg';

export const NoResults = (): ReactElement => (
  <CoreNoResults
    className='InfoView--ImageRight'
    iconType={ICON_TYPE.warning}
    image={{
      default: image,
      retina: retinaImage,
    }}
  />
);
